package com.jingfangpai.common.data.type

import com.jingfangpai.common.data.serializer.BigDecimalSerializer
import ext.toFixed
import kotlinx.serialization.Serializable

@Serializable(with = BigDecimalSerializer::class)
actual class BigDecimal actual constructor(private val doubleVal: Double){
    actual constructor(strVal: String) : this(strVal.toDouble())
    actual constructor(intVal: Int) : this(intVal.toDouble())
    actual constructor(longVal: Long) : this(longVal.toDouble())
    @JsName("compareTo")
    actual fun compareTo(other: BigDecimal): Int= doubleVal.compareTo(other.doubleVal)

    // These can become override methods once we are able to extend kotlin.Number
    @JsName("toByte")
    actual fun toByte(): Byte = doubleVal.toInt().toByte()
    @JsName("toChar")
    actual fun toChar(): Char = doubleVal.toInt().toChar()
    @JsName("toDouble")
    actual fun toDouble(): Double {
       return doubleVal
    }
    @JsName("toFloat")
    actual fun toFloat(): Float = doubleVal.toFloat()
    @JsName("toInt")
    actual fun toInt(): Int = doubleVal.toInt()
    @JsName("toLong")
    actual fun toLong(): Long = doubleVal.toLong()
    @JsName("toShort")
    actual fun toShort(): Short = doubleVal.toInt().toShort()
    @JsName("toFixed")
    actual fun toFixed(scale:Int):BigDecimal{
        return BigDecimal(this.toDouble().toFixed(scale));
    }
    @JsName("add")
    actual fun add(augend: BigDecimal): BigDecimal = BigDecimal(doubleVal + augend.doubleVal)
    @JsName("subtract")
    actual fun subtract(subtrahend: BigDecimal): BigDecimal = BigDecimal(doubleVal - subtrahend.doubleVal)
    @JsName("multiply")
    actual fun multiply(multiplicand: BigDecimal): BigDecimal = BigDecimal(doubleVal * multiplicand.doubleVal)
    @JsName("divide")
    actual fun divide(divisor: BigDecimal): BigDecimal = BigDecimal(doubleVal / divisor.doubleVal)
    @JsName("remainder")
    actual fun remainder(divisor: BigDecimal): BigDecimal = BigDecimal(doubleVal % divisor.doubleVal)
    @JsName("negate")
    actual fun negate(): BigDecimal = this * NEGATIVE_ONE

    actual override fun toString():String{
        return doubleVal.toString()
    }
}
